import { FaberApi } from 'api'
import { AxiosPromise } from 'axios'
import {
  getCreditsType,
  getUserPlanType,
  getWinbackPlansType,
  provisionWaiverType,
  responseType
} from 'types/api/faber/winback.type'

class WinbackAPI {
  /** to get/post all the winback dAPI
   * @returns
   */
  static hotelCreditsWinback(body: {
    userId: string
    faberToken: string
  }): AxiosPromise<getCreditsType> {
    return FaberApi.httpPost(
      `/vouchers/user`,
      { Authorization: `Bearer ${body.faberToken}` },
      body
    )
  }

  static updateHotelCreditsWinback(body: {
    userId: string
    voucherCreditChange: number
    faberToken: string
  }): AxiosPromise<responseType> {
    return FaberApi.httpPost(
      `/vouchers/user/update`,
      { Authorization: `Bearer ${body.faberToken}` },
      body
    )
  }

  static getBonusDataPlans(
    faberToken: string
  ): AxiosPromise<getWinbackPlansType> {
    return FaberApi.httpGet(`/catalog/winback/plans`, {
      Authorization: `Bearer ${faberToken}`
    })
  }

  static updateBonusDataPlans(body: {
    userID: string
    packageTypeID: string
    remarks: string
    faberToken: string
  }): AxiosPromise<responseType> {
    return FaberApi.httpPost(
      `/esim/provision/package/single`,
      { Authorization: `Bearer ${body.faberToken}` },
      body
    )
  }

  static externalUpdateBonusDataPlans(body: {
    userID: string
    packageTypeID: string
    remarks: string
    faberToken: string
  }): AxiosPromise<responseType> {
    return FaberApi.httpPost(
      `/ops/esim/provision/package/single`,
      { Authorization: `Bearer ${body.faberToken}` },
      body
    )
  }

  static getUserPlans(
    faberToken: string,
    customerId: string
  ): AxiosPromise<getUserPlanType> {
    return FaberApi.httpGet(`/waivers/userplan/${customerId}`, {
      Authorization: `Bearer ${faberToken}`
    })
  }

  static provisionWaiver(body: {
    userID: string
    currency: string | undefined
    waiverValue: number
    planName: string | undefined
    months: number
    faberToken: string
  }): AxiosPromise<provisionWaiverType> {
    return FaberApi.httpPost(
      `/waivers/provision`,
      { Authorization: `Bearer ${body.faberToken}` },
      body
    )
  }
}

export default WinbackAPI
